import { Navigate } from "react-router-dom";
import PageTitle from "../page-header/PageHeader";

import AddExpense from "./AddExpense";

const Expense = (props) => {
	const isLogged = Boolean(localStorage.getItem("isLogged"));

	if (!isLogged) {
		return <Navigate to={"/admin/auth/login"} replace={true} />;
	}
	return (
		<div>
			<PageTitle title='Back' />
			<AddExpense />
		</div>
	);
};

export default Expense;
